/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Period_EndInputs */

const en_settings_billing_period_end = /** @type {(inputs: Settings_Billing_Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period end`)
};

const zh_settings_billing_period_end = /** @type {(inputs: Settings_Billing_Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本期结束`)
};

/**
* | output |
* | --- |
* | "Period end" |
*
* @param {Settings_Billing_Period_EndInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_period_end = /** @type {((inputs?: Settings_Billing_Period_EndInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Period_EndInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_period_end(inputs)
	return zh_settings_billing_period_end(inputs)
});
export { settings_billing_period_end as "settings.billing.period_end" }